import React, { useContext, useEffect } from "react";
import MyContext from "../context/MyContext";
import { Link } from "react-router-dom";
import axios from "axios";

const OrderHistory = () => {
  const context = useContext(MyContext);
  const { history, setHistory} = context;

  useEffect(() => {
    const getHistory = async () => {
      const res = await axios.get("/users/history");
      setHistory(res.data);
    };
    getHistory();
  }, [setHistory]);

  return (
    <div className="history-page">
      <h2>History</h2>
      <h4>You have {history.length} ordered</h4>
      <table>
        <thead>
          <tr>
            <th>Payment ID</th>
            <th>Date of Purchased</th>
            <th>Order Details</th>
          </tr>
        </thead>
        <tbody>
          {history.map((items) => (
            <tr key={items._id}>
              <td>{items.paymentID}</td>
              <td>{new Date(items.createdAt).toLocaleDateString()}</td>
              <td>
                <Link to={`/orderdetails/${items._id}`}>View</Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OrderHistory;
